import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "drawer-content" };
const _hoisted_2 = { class: "note-form" };
const _hoisted_3 = { class: "form-content" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = ["value"];
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = ["value"];
const _hoisted_9 = { class: "form-group" };
const _hoisted_10 = { class: "notes-list" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = {
    key: 1,
    class: "loading"
};
const _hoisted_13 = { key: 2 };
const _hoisted_14 = { class: "note-meta" };
const _hoisted_15 = { class: "meta-row" };
const _hoisted_16 = { class: "meta-value" };
const _hoisted_17 = { class: "meta-row" };
const _hoisted_18 = { class: "meta-value" };
const _hoisted_19 = { class: "meta-row" };
const _hoisted_20 = { class: "meta-value" };
const _hoisted_21 = {
    key: 0,
    class: "meta-row"
};
const _hoisted_22 = { class: "meta-value" };
const _hoisted_23 = { class: "note-text" };
const _hoisted_24 = {
    key: 3,
    class: "empty"
};
import { ref, reactive, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerNotesDrawer',
    props: {
        show: { type: Boolean },
        notes: { default: () => [] },
        loading: { type: Boolean, default: false },
        methodOptions: { default: () => ['zendesk', 'phone', 'email', 'in-person', 'chat', 'other'] },
        reasonOptions: { default: () => ['inquiry', 'complaint', 'follow-up', 'support', 'other'] },
        customers: { default: () => [] }
    },
    emits: ["close", "error", "add-note"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const formExpanded = ref(false);
        const newNote = reactive({
            method: 'phone',
            reason: 'inquiry',
            note: '',
            contactDateTime: '',
            customMethod: '',
            customReason: ''
        });
        function getCreatedByEmail(note) {
            if (note.addedByCustomerID && props.customers && props.customers.length > 0) {
                const creator = props.customers.find(c => c.id === note.addedByCustomerID);
                if (creator && creator.person && creator.person.email) {
                    return creator.person.email;
                }
            }
            return null;
        }
        function closeDrawer() {
            emit('close');
        }
        function addNote() {
            if (!newNote.note.trim()) {
                emit('error', 'Please enter a note');
                return;
            }
            if (newNote.method === 'other' && !newNote.customMethod.trim()) {
                emit('error', 'Please enter a custom method');
                return;
            }
            if (newNote.reason === 'other' && !newNote.customReason.trim()) {
                emit('error', 'Please enter a custom reason');
                return;
            }
            const noteData = {
                contactDateTime: new Date(newNote.contactDateTime).toISOString(),
                method: newNote.method === 'other' ? newNote.customMethod : newNote.method,
                reason: newNote.reason === 'other' ? newNote.customReason : newNote.reason,
                note: newNote.note
            };
            emit('add-note', noteData);
            resetForm();
        }
        function resetForm() {
            const now = new Date();
            const isoString = now.toISOString();
            const localDateTime = isoString.slice(0, 16);
            newNote.method = 'phone';
            newNote.reason = 'inquiry';
            newNote.note = '';
            newNote.contactDateTime = localDateTime;
            newNote.customMethod = '';
            newNote.customReason = '';
        }
        function formatDateTime(dateString) {
            if (!dateString)
                return '';
            const date = new Date(dateString);
            return date.toLocaleString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
        function initializeForm() {
            const now = new Date();
            const isoString = now.toISOString();
            const localDateTime = isoString.slice(0, 16);
            newNote.contactDateTime = localDateTime;
        }
        watch(() => props.show, (newVal) => {
            if (newVal) {
                initializeForm();
            }
        });
        return (_ctx, _cache) => {
            return (_ctx.show)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "drawer-overlay",
                    onClick: closeDrawer
                }, [
                    _createElementVNode("div", {
                        class: "drawer notes-drawer",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", { class: "drawer-header" }, [
                            _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Customer Notes", -1)),
                            _createElementVNode("button", {
                                class: "close-btn",
                                onClick: closeDrawer
                            }, "✕")
                        ]),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", {
                                    class: "form-header",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (formExpanded.value = !formExpanded.value))
                                }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Add New Note", -1)),
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["toggle-icon", { expanded: formExpanded.value }])
                                    }, "▼", 2)
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _cache[10] || (_cache[10] = _createElementVNode("label", null, "Contact Date/Time:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((newNote.contactDateTime) = $event)),
                                            type: "datetime-local",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, newNote.contactDateTime]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_5, [
                                        _cache[11] || (_cache[11] = _createElementVNode("label", null, "Method:", -1)),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((newNote.method) = $event)),
                                            class: "form-input"
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.methodOptions, (method) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: method,
                                                    value: method
                                                }, _toDisplayString(method), 9, _hoisted_6));
                                            }), 128))
                                        ], 512), [
                                            [_vModelSelect, newNote.method]
                                        ]),
                                        (newNote.method === 'other')
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((newNote.customMethod) = $event)),
                                                type: "text",
                                                class: "form-input",
                                                placeholder: "Enter custom method...",
                                                style: { "margin-top": "8px" }
                                            }, null, 512)), [
                                                [_vModelText, newNote.customMethod]
                                            ])
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _cache[12] || (_cache[12] = _createElementVNode("label", null, "Reason:", -1)),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((newNote.reason) = $event)),
                                            class: "form-input"
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasonOptions, (reason) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    key: reason,
                                                    value: reason
                                                }, _toDisplayString(reason), 9, _hoisted_8));
                                            }), 128))
                                        ], 512), [
                                            [_vModelSelect, newNote.reason]
                                        ]),
                                        (newNote.reason === 'other')
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((newNote.customReason) = $event)),
                                                type: "text",
                                                class: "form-input",
                                                placeholder: "Enter custom reason...",
                                                style: { "margin-top": "8px" }
                                            }, null, 512)), [
                                                [_vModelText, newNote.customReason]
                                            ])
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[13] || (_cache[13] = _createElementVNode("label", null, "Note:", -1)),
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((newNote.note) = $event)),
                                            class: "form-textarea",
                                            rows: "4",
                                            placeholder: "Enter your note here..."
                                        }, null, 512), [
                                            [_vModelText, newNote.note]
                                        ])
                                    ]),
                                    _createElementVNode("button", {
                                        class: "action-btn primary",
                                        onClick: addNote
                                    }, " Add Note ")
                                ], 512), [
                                    [_vShow, formExpanded.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                (_ctx.notes.length > 0)
                                    ? (_openBlock(), _createElementBlock("h4", _hoisted_11, "Existing Notes (" + _toDisplayString(_ctx.notes.length) + ")", 1))
                                    : _createCommentVNode("", true),
                                (_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Loading notes..."))
                                    : (_ctx.notes.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: note.id || index,
                                                    class: "note-item"
                                                }, [
                                                    _createElementVNode("div", _hoisted_14, [
                                                        _createElementVNode("div", _hoisted_15, [
                                                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "meta-label" }, "Date:", -1)),
                                                            _createElementVNode("span", _hoisted_16, _toDisplayString(formatDateTime(note.createDateTime)), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_17, [
                                                            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "meta-label" }, "Contact:", -1)),
                                                            _createElementVNode("span", _hoisted_18, _toDisplayString(note.method), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_19, [
                                                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "meta-label" }, "Reason:", -1)),
                                                            _createElementVNode("span", _hoisted_20, _toDisplayString(note.reason), 1)
                                                        ]),
                                                        (getCreatedByEmail(note))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "meta-label" }, "By:", -1)),
                                                                _createElementVNode("span", _hoisted_22, _toDisplayString(getCreatedByEmail(note)), 1)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_23, _toDisplayString(note.note), 1)
                                                ]));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_24, "No notes yet"))
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
